<template>
    <div
        class="container-modal d-flex flex-column justify-content-center align-items-center d-block"
        :class="['lightbox-' + hotspot.hotspotId, isValid100PercentageWidth > -1 ? 'lightbox-100-percentage-width' : 'position-relative']"
        v-if="isVisible"
        :id="['lightbox-' + hotspot.hotspotId]">
        <div class="modal-background" />
        <div class="modal-content">
            <header class="modal-body-head d-flex justify-content-end align-items-center"
                    v-if="haveExternalClose === -1">
                <div
                    class="close-container-modal"
                    aria-label="close"
                    @click="closeModal"
                >
                    <div class="close-modal-icon" />
                </div>
            </header>
            <section
                :id="['mdlBody-' + hotspot.hotspotId]"
                class="modal-body"
            >
                <div v-html="content" />
            </section>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick, onMounted, onBeforeUnmount } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import { debounce } from "lodash";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS
const props = defineProps({
    hotspot: {
        type: Object,
        required: true,
    },
});

// REACTIVE VARIABLES
const haveExternalClose = ref(-1);

// COMPUTED PROPERTIES
const isValid100PercentageWidth = computed(() => {
    return validClassContainer("lightbox100PercentageWidth");
});

const content = computed(() => {
    return getContent("closeModal");
});

const isVisible = computed(() => {
    if (!store.getActiveHotspot) {
        return false;
    }
    $('#bottom-button-bar').css({
        opacity: 1, bottom: -50, padding: 0, transition: '0.3s',
    });
    return props.hotspot.hotspotId === store.getActiveHotspot.hotspotId;
});

// METHODS
const activeGallery = () => {
    if (props.hotspot.hotspotAction.actionType.actionTypeId == 1) {
        let galleryComp = $(".vtm-gallery-light");
        galleryComp.lightGallery({
            download: false,
            autoplay: false,
            progressBar: false,
            autoplayControls: false,
            fullScreen: false,
            hash: false,
            share: false
        });
    }
};

const closeModal = () => {
    $('#bottom-button-bar').css({ opacity: 1, bottom: -1, transition: '0.3s' });

    store.addActiveHotspot(null);
    store.getPlayer.play();
};

const getContent = (tagName) => {
    nextTick(debounce(() => {
        activeGallery();
    }, 50));

    let codeHTML = props.hotspot.hotspotAction.parameter;
    codeHTML = replaceDataVariableInHotspot(codeHTML);
    if (isIOS()) {
        codeHTML = rewritePdfIframes(codeHTML);
    }
    haveExternalClose.value = codeHTML.search(tagName);
    return codeHTML;
};

const replaceDataVariableInHotspot = (itemHTML) => {
    const path = store.getPathLocalOrServer;
    const varRegExp = new RegExp(/%%(.*?)%%/g);
    //const varRegExpDefault = new RegExp(/##(.*?)##/g);
    const variables = itemHTML.match(varRegExp);

    if (variables) {
        variables.forEach((variable) => {
            const varRegExp2 = new RegExp(/%%(.*?)%%/g);
            const variableName = variable.match(varRegExp2)[0].replace(/%/g, '');
            const variableValue = store.getDataVariableByVariableName(variableName);
            if (variableValue.length > 0) {
                if (variableValue[0].path != null) {
                    itemHTML = itemHTML.replace(variable, path + 'images_variables/' + variableValue[0].path);
                } else {
                    itemHTML = itemHTML.replace(variable, variableValue[0].description);
                }
            } else {
                const parser = new DOMParser();
                const doc = parser.parseFromString(itemHTML, 'text/html');
                const elements = Array.from(doc.querySelectorAll('*')).filter(element => {
                    return Array.from(element.attributes).some(attr => attr.value === variable);
                });

                elements.forEach(element => {
                    if (element.dataset['type'] != undefined && element.dataset['type'] == 'image') {
                        itemHTML = itemHTML.replace(variable, path + 'images_variables/' + element.dataset['default']);
                    } else {
                        itemHTML = itemHTML.replace(variable, element.dataset['default']);
                    }
                });
            }
        });
    }

    return itemHTML;
};

const validClassContainer = (tagName) => {
    let codeHTML = props.hotspot.hotspotAction.parameter;
    return codeHTML.search("lightbox100PercentageWidth");
};

const PDF_VIEWER = `${window.location.origin}/pdfjs/web/viewer.html`

const ALLOWED_PDF_PREFIXES = [
    'https://s3.amazonaws.com/video2market/',
    'https://video2market.s3.amazonaws.com/',
]

function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

function rewritePdfIframes(html) {
    if (!html) return html
    const tpl = document.createElement('template')
    tpl.innerHTML = html
    tpl.content.querySelectorAll('iframe[src]').forEach(el => {
        const src = el.getAttribute('src') || ''
        const isPdf = /\.pdf(\?|#|$)/i.test(src)
        const isOurs = ALLOWED_PDF_PREFIXES.some(p => src.startsWith(p))
        if (isPdf && isOurs) {
            el.setAttribute('src', `${PDF_VIEWER}?file=${encodeURIComponent(src)}`)
        }
    })
    return tpl.innerHTML
}

// LYFECYCLE HOOKS
onMounted(() => {
    window.closeModal = closeModal;
});

onBeforeUnmount(() => {
    delete window.closeModal;
});
</script>
